import { IS_CLIENT, IS_PRODUCTION } from '@repo/common-utils';
import { Analytics, getAnalytics, setUserProperties } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { fetchAndActivate, getRemoteConfig, getValue, RemoteConfig } from 'firebase/remote-config';
import { useEffect, useState } from 'react';

export let isFirebaseInit = false;
export let firebaseAnalytics: Analytics;
export let remoteConfig: RemoteConfig;
const firebaseOption = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_APIKEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASEURL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECTID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APPID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENTID
};

const initializeFirebase = () => {
  if (firebaseOption.projectId && !isFirebaseInit) {
    const app = initializeApp(firebaseOption);
    if (app.name) {
      firebaseAnalytics = getAnalytics(app);
      remoteConfig = getRemoteConfig(app);
      remoteConfig.settings.minimumFetchIntervalMillis = process.env.NEXT_PUBLIC_ZENV === 'loc' ? 0 : 60000;
    }

    isFirebaseInit = true;

    setUserProperties(firebaseAnalytics, {
      traffic_type: !IS_PRODUCTION ? 'internal' : 'user'
    });
  }
};

/**
 * Firebase 초기화
 */
export function useFirebaseInit() {
  if (IS_CLIENT) {
    initializeFirebase();
  }
}

export const useRemoteConfig = (key: string) => {
  const [value, setValue] = useState<any>();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const fetchedValue = getValue(remoteConfig, key).asString();
        try {
          setValue(JSON.parse(fetchedValue));
        } catch {
          setValue(fetchedValue);
        }
      } catch (error) {
        console.error('Failed to fetch Remote Config', error);
      }
    };

    if (!remoteConfig) {
      initializeFirebase();
    }
    fetchConfig();
  }, [key]);

  return value;
};
